import { AnyAction } from "redux";
import {
  CLOSE_SIDEBAR, OPEN_SIDEBAR, TOGGLE_SIDEBAR,
  OPEN_MOBILE_SIDEBAR, CLOSE_MOBILE_SIDEBAR, TOGGLE_MOBILE_SIDEBAR,
} from "../types";

interface SidebarState {
  /** Desktop collapse: expanded (full) vs the icon rail. */
  isOpen: boolean;
  /** Mobile drawer: open vs off-canvas. Only meaningful below the lg breakpoint. */
  mobileOpen: boolean;
}

const initialState: SidebarState = {
  isOpen: true,
  mobileOpen: false,
};

const sidebarReducer = (state = initialState, action: AnyAction): SidebarState => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return { ...state, isOpen: !state.isOpen };
    case OPEN_SIDEBAR:
      return { ...state, isOpen: true };
    case CLOSE_SIDEBAR:
      return { ...state, isOpen: false };
    case OPEN_MOBILE_SIDEBAR:
      return { ...state, mobileOpen: true };
    case CLOSE_MOBILE_SIDEBAR:
      return { ...state, mobileOpen: false };
    case TOGGLE_MOBILE_SIDEBAR:
      return { ...state, mobileOpen: !state.mobileOpen };
    default:
      return state;
  }
};

export default sidebarReducer;
